import React, { Fragment } from 'react'
import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const NotFoundPage = props => {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <Result
        status="404"
        title="404"
        subTitle="Trang bạn tìm kiếm không tồn tại."
        extra={
          <Fragment>
            <Button onClick={() => navigate(-1)}>Quay lại trang trước</Button>
            <Button type={'primary'} onClick={() => navigate('/')}>
              Về trang chủ
            </Button>
          </Fragment>
        }
      />
    </Wrapper>
  )
}

export default NotFoundPage
